import ManufacturerDataGrid from './ManufacturerDataGrid';

export default ManufacturerDataGrid;
export * from './ManufacturerDataGrid';
